import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/atoms/Icon/';
import classNames from 'classnames';

// Constants
import { NAVIGATION } from 'constants/navigations';

// Utils
import { isEmpty } from 'utils/string';

import './ButtonHeader.scss';

const ns = 'button-header';
const { BACKWARD } = NAVIGATION;

const ButtonHeader = ({
  label,
  type,
  to,
  onClick,
  className,
  goTo,
  ariaLabel,
  disabled
}) => {
  const classProps = classNames({
    [className]: true,
    [ns]: true,
    [`${ns}__${type}`]: true,
    [`${ns}--disabled`]: disabled
  });
  const isBackButton = type === 'back' || type === 'cta-back';

  const onClickButton = () => {
    onClick();
    if (!isEmpty(to)) {
      goTo(to, BACKWARD);
    }
  };

  return (
    <div
      tabIndex={isBackButton ? -1 : 0}
      className={classProps}
      onClick={() => {
        onClickButton();
      }}
      onKeyUp={event => {
        if (event.key === 'Enter' && !disabled) {
          onClickButton();
        }
      }}
    >
      <div>
        {isBackButton && (
          <Icon
            tabIndex={0}
            type="arrow__back"
            className={`${ns}__icon`}
            id="back_arrow_icon"
            aria-label={ariaLabel}
          />
        )}
        <span
          className={`${ns}__label`}
          aria-label={isBackButton ? '' : ariaLabel}
          aria-disabled={disabled}
        >
          {label}
        </span>
      </div>
    </div>
  );
};

ButtonHeader.propTypes = {
  className: PropTypes.string,
  goTo: PropTypes.func.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.string,
  type: PropTypes.string,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool
};
ButtonHeader.defaultProps = {
  className: '',
  ariaLabel: '',
  type: 'back',
  to: '',
  onClick: () => {},
  disabled: false
};

export default ButtonHeader;



// WEBPACK FOOTER //
// ./src/components/atoms/ButtonHeader/ButtonHeader.js